import { useStaticQuery, graphql } from "gatsby"

const useCreativeDesigns = () => {
  
  const data = useStaticQuery(graphql`
      query CreativeCommunityDesignQuery {
        creativeProductTypes: allContentfulCreativeCommunityDesign {
          distinct(field: productType)
        }
        creativeDesignStyle: allContentfulCreativeCommunityDesign {
          distinct(field: designStyle)
        }
        creativeDesignTemplateType: allContentfulCreativeCommunityDesign {
          distinct(field: designType)
        }
        creativeDesigns: allContentfulCreativeCommunityDesign(
          filter: {node_locale: {eq: "en-US"}}
        ) {
          nodes {
            designTitle
            createdAt
            productType
            designsFiles {
              file {
                url
              }
            }
            
            designType
            designStyle
            designer
            designerProfile {
              partnerLogo {
                file {
                  url
                }
                title
              }
              partnerName
              partnerCountry
            }
          }
        }
      }
    `);

  return data;
}

export default useCreativeDesigns;
